import {
  Banner,
  Button,
  IconInformationAlt,
} from '@spotify-internal/encore-web';

import styles from './ConnectBanner.module.css';

interface ConnectBannerProps {
  providerLabel: string;
  resourceLabel: string;
  connectionError: string | null;
  isConnecting: boolean;
  onConnect: () => void;
}

export const ConnectBanner = ({
  providerLabel,
  resourceLabel,
  connectionError,
  isConnecting,
  onConnect,
}: ConnectBannerProps) => (
  <Banner
    contextual
    size="small"
    colorSet={connectionError ? 'negative' : 'announcementSubdued'}
    className={styles.wrapper}
    renderIcon={({ size }) => <IconInformationAlt size={size} aria-hidden />}
  >
    <div className={styles.content}>
      <span>
        {connectionError ??
          `Connect your ${providerLabel} account to attach this ${resourceLabel}.`}
      </span>
      <Button
        variant="secondary-bordered"
        size="small"
        onClick={onConnect}
        disabled={isConnecting}
        isLoading={isConnecting}
       data-track-source-anchor="961dc76fe7;connect-banner-button">
        {connectionError ? 'Try again' : 'Connect'}
      </Button>
    </div>
  </Banner>
);
